import React from "react";
import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";

import GesubsidieerdeClubsOverinstIcon from "./svg/GesubsidieerdeClubsOverinstIcon";
import ErkendeClubsGemeenteIcon from "./svg/ErkendeClubsGemeenteIcon";

const SportdienstStatusByGemeenteIcon = (props) => {

    const { type } = props;

    let svgcontent = {
        [types.ICON_GESUBSIDIEERDDOOR]: GesubsidieerdeClubsOverinstIcon,
        [types.ICON_ERKENDDOORGEMEENTE]: ErkendeClubsGemeenteIcon,
    };

    let svgpaths = svgcontent[types.ICON_ERKENDDOORGEMEENTE];
    if (type) {
        svgpaths = svgcontent[type] || svgcontent[types.ICON_ERKENDDOORGEMEENTE];
    }

    return (svgpaths(types.COLOR_BLUE));
};

SportdienstStatusByGemeenteIcon.propTypes = {
    type: PropTypes.string
};

export default SportdienstStatusByGemeenteIcon;